"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components")); // TODO: will use the width from our theme once we finalise it


var AFFIX_WIDTH = '56px';
exports.Input = styled_components_1.default.input(function (_a) {
  var theme = _a.theme,
      isValid = _a.isValid;
  var textInput = theme.components.textInput;
  return {
    '::placeholder': {
      color: theme.border.default
    },
    ':disabled': {
      backgroundColor: theme.background.disabled,
      borderColor: theme.border.disabled,
      color: theme.color.disabled,
      cursor: 'not-allowed'
    },
    ':focus': {
      outline: 0
    },
    ':valid': {},
    ':not(:first-child)': {
      borderLeft: textInput.default.borderWidth + " solid " + (isValid === undefined ? theme.border.default : isValid ? theme.border.active : theme.border.dirty)
    },
    ':not(:last-child)': {
      borderRight: textInput.default.borderWidth + " solid " + (isValid === undefined ? theme.border.default : isValid ? theme.border.active : theme.border.dirty)
    },
    backgroundColor: 'inherit',
    border: 'none',
    boxSizing: 'border-box',
    color: isValid === undefined ? theme.color.default : isValid ? theme.color.active : theme.color.dirty,
    fontFamily: theme.fontText,
    fontSize: theme.size.medium,
    padding: theme.space.small,
    width: '100%'
  };
});
exports.Wrapper = styled_components_1.default.span(function (_a) {
  var theme = _a.theme,
      isOnFocus = _a.isOnFocus,
      isValid = _a.isValid;
  var textInput = theme.components.textInput;
  return {
    display: 'flex',
    border: textInput.default.borderWidth + " solid " + (isValid === undefined ? theme.border.default : isValid ? theme.border.active : theme.border.dirty),
    borderRadius: theme.radius,
    boxShadow: !isOnFocus ? 'none' : isValid === undefined ? theme.shadow.default : isValid ? theme.shadow.active : theme.shadow.dirty,
    backgroundColor: isOnFocus ? theme.background.default : isValid === undefined ? theme.background.default : isValid ? theme.background.active : theme.background.dirty,
    margin: theme.component.margin + " 0px"
  };
});
exports.Addon = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-width: ", ";\n"], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-width: ", ";\n"])), AFFIX_WIDTH);
var templateObject_1;